import { Routes } from '@angular/router';
import {
  ChangeVoicemailConfigService,
  changeVoicemailPasswordRoutes,
} from '@rogers/self-serve-wireless/change-voicemail-password';
import { getWirelessDeeplinkGuard } from '@rci/self-serve-fido/guard/routing.guards';
import {
  provideAnalyticsConfigurationUsingClass,
  provideSelfServeAnalyticsService,
} from '@rci/self-serve-fido/core/analytics';
import { ChangeVoicemailAnalyticsConfigurationService } from './analytics/change-voicemail-analytics-configuration.service';
import { ChangeVoicemailAppConfigService } from './change-voicemail-app.config.service';
import { BreadcrumbsService } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.service';

export const changeVoicemailPasswordAppRoutes: Routes = [
  {
    path: 'change-voicemail-password',
    children: changeVoicemailPasswordRoutes,
    canActivate: getWirelessDeeplinkGuard('change-voicemail-password'),
    providers: [
      provideAnalyticsConfigurationUsingClass(ChangeVoicemailAnalyticsConfigurationService),
      provideSelfServeAnalyticsService(),
      {
        provide: ChangeVoicemailConfigService,
        useClass: ChangeVoicemailAppConfigService,
        deps: [BreadcrumbsService],
      },
    ],
  },
];
